<template>
  <div class="card fb-palette">
    <div class="card-header">
      <span class="card-title mb-0">Adicionar campo</span>
    </div>
    <div class="card-body p-2">
      <span class="fb-palette__group">Perguntas</span>
      <button
        v-for="type in questionTypes"
        :key="type.value"
        type="button"
        class="fb-palette__btn"
        @click="$emit('add', type.value)"
      >
        <span class="fb-palette__icon">
          <feather-icon
            :icon="type.icon"
            size="14"
          />
        </span>
        <span class="fb-palette__label">{{ type.label }}</span>
        <feather-icon
          icon="PlusIcon"
          size="13"
          class="fb-palette__plus"
        />
      </button>

      <span class="fb-palette__group mt-2">Estrutura</span>
      <button
        v-for="type in structureTypes"
        :key="type.value"
        type="button"
        class="fb-palette__btn fb-palette__btn--structure"
        @click="$emit('add', type.value)"
      >
        <span class="fb-palette__icon">
          <feather-icon
            :icon="type.icon"
            size="14"
          />
        </span>
        <span class="fb-palette__label">{{ type.label }}</span>
        <feather-icon
          icon="PlusIcon"
          size="13"
          class="fb-palette__plus"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { FIELD_TYPE_CATALOG } from './fieldTypes'

export default {
  name: 'FieldPalette',
  computed: {
    // "Quebra de seção" não é um tipo de pergunta — fica separada por um
    // divisor, como pedido no mockup, para não parecer mais uma opção de
    // resposta entre as demais.
    questionTypes() {
      return FIELD_TYPE_CATALOG.filter(t => t.value !== 'section_break')
    },
    structureTypes() {
      return FIELD_TYPE_CATALOG.filter(t => t.value === 'section_break')
    },
  },
}
</script>

<style scoped>
.fb-palette__group {
  display: block;
  margin: 0 0 6px 2px;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #b9b9c3;
}

.fb-palette__btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 4px;
  padding: 7px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  color: #6e6b7b;
  font-size: 0.82rem;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s, color 0.12s;
}
.fb-palette__btn:hover {
  background: #f5f4ff;
  border-color: #d6d1fa;
  color: #7367f0;
}

.fb-palette__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #f0eefe;
  color: #7367f0;
}
.fb-palette__btn--structure .fb-palette__icon {
  background: #eef4fb;
  color: #2f6bb3;
}

.fb-palette__label {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.25;
}

.fb-palette__plus {
  flex: 0 0 auto;
  opacity: 0;
  transition: opacity 0.12s;
}
.fb-palette__btn:hover .fb-palette__plus {
  opacity: 1;
}

.dark-layout .fb-palette__btn {
  color: #d0d2d6;
}
.dark-layout .fb-palette__btn:hover {
  background: #2c3247;
  border-color: #3b4253;
  color: #a89dfb;
}
.dark-layout .fb-palette__icon {
  background: #2c3247;
}
.dark-layout .fb-palette__btn--structure .fb-palette__icon {
  background: #1f3555;
  color: #8ab4e8;
}
</style>
